export const ALL = 'all';
export const PRINT = 'print';
export const SCREEN = 'screen';
export const SPEECH = 'speech';